export const images = [
  "image/art/holiday-cards.JPG",
  "image/art/taiwan-night-markets.PNG",
  "image/art/boba-cat-pins.JPG",
  "image/art/cat-hearts.png",
  "image/art/karl-the-fog.png",
  "image/art/boba-panda.png",
  "image/art/2024-3-23-fly-no-border.png",
  "image/art/synco-audition-poster-2023.png",
  "image/project-previews/koi-cards-preview.png",
  "image/art/koi-cards-printed-back-dark.jpeg",
  "image/art/synco-concert-poster-2021.png",
  "image/art/quiescence-album-art.png",

];
